//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "LegacyCaseStudy",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
